import React from 'react';
import { Button } from 'primereact/button';

/**
 * IngredientsOverview - Pure UI component voor machine ingredients weergave en filtering
 * Alle logica blijft in de parent component voor veiligheid
 */
const IngredientsOverview = ({
	// Data
	machineIngredients,
	selectedIngredients,
	ingredientMatchMode,
	
	// Event handlers (blijven in parent)
	onIngredientToggle,
	onMatchModeChange, 
	onFilterClear
}) => {
	return (
		<div className="ingredients-overview">
			<div className="overview-header">
				<h4 className="section-heading">
					<i className="pi pi-circle overview-icon"></i>
					Machine Ingredients
				</h4>
				<div className="ingredient-filter-controls">
					{selectedIngredients.length > 1 && (
						<div className="match-mode-toggle">
							<Button
								label="Contains any"
								size="small"
								outlined={ingredientMatchMode !== 'any'}
								severity={ingredientMatchMode === 'any' ? 'primary' : 'secondary'}
								onClick={() => onMatchModeChange('any')}
								className="match-mode-btn-mini mr-1"
							/>
							<Button
								label="Contains all"
								size="small"
								outlined={ingredientMatchMode !== 'all'}
								severity={ingredientMatchMode === 'all' ? 'primary' : 'secondary'}
								onClick={() => onMatchModeChange('all')}
								className="match-mode-btn-mini"
							/>
						</div>
					)}
					{selectedIngredients.length > 0 && (
						<Button
							severity='danger'
							icon="pi pi-times"
							label={`Clear (${selectedIngredients.length})`}
							text
							size="small"
							onClick={onFilterClear}
							className="clear-ingredient-filter-btn"
						/>
					)}
				</div>
			</div>
			
			{selectedIngredients.length > 0 && (
				<div className="ingredient-filter-status">
					<div className="filter-status-content">
						<i className="pi pi-filter status-icon"></i>
						<span className="status-text">
							Filtering recipes {ingredientMatchMode === 'any' ? 'containing any' : 'containing all'} of the following ingredients: {selectedIngredients.join(', ')}
						</span>
					</div>
				</div>
			)}
			
			<div className="overview-legend">
				<div className="legend-item">
					<div className="legend-dot legend-dot--used"></div>
					<span className="legend-text">Used <small>(Shows for selected recipe)</small></span>
				</div>
				<div className="legend-item">
					<div className="legend-dot legend-dot--unused"></div>
					<span className="legend-text">Unused <small>(not in machine)</small></span>
				</div>
				{selectedIngredients.length > 0 && (
					<div className="legend-item">
						<div className="legend-dot legend-dot--filtered"></div>
						<span className="legend-text">Selected ingredient{selectedIngredients.length === 1 ? '' : 's'} ({selectedIngredients.length})</span>
					</div>
				)}
			</div>
			
			<div className="overview-grid">
				{machineIngredients &&
					machineIngredients.map((ingredient, index) => {
						const isSelected = selectedIngredients.includes(ingredient.flavor.name);
						return (
							<div
								key={index}
								onClick={() => onIngredientToggle(ingredient.flavor.name)}
								className={`overview-ingredient-chip ${isSelected ? 'overview-ingredient--filtered' : ''}`}
								data-ingredient={ingredient.flavor.name}
								role="button"
								tabIndex={0}
								style={{ cursor: 'pointer' }}
								aria-label={`${isSelected ? 'Remove' : 'Add'} ${ingredient.flavor.name} from filter`}
							>
								<img 
									src={ingredient.flavor.icon} 
									alt={ingredient.flavor.name}
									className="overview-ingredient-icon"
								/>
								<span className="overview-ingredient-label">
									{ingredient.flavor.name}
								</span>
								{isSelected && (
									<div className="filtered-indicator">
										<i className="pi pi-filter"></i>
									</div>
								)}
							</div>
						);
					})}
			</div>
		</div>
	);
};

export default IngredientsOverview;
